import React from 'react';

type TableBodyContext = {
  isTableBody: boolean;
};

export const TableBodyContext = React.createContext<TableBodyContext>({ isTableBody: false });
